import { flexRender, type Table, type ColumnDef } from "@tanstack/react-table";

interface DataTableProps<TData> {
  table: Table<TData>;
  columns: ColumnDef<TData>[];
  loading?: boolean;
}

export function CustomTable<TData>({
  table,
  columns,
  loading = false,
}: DataTableProps<TData>) {
  return (
    <div className="bg-white rounded-md">
      <div className="relative overflow-auto">
        <table className="caption-bottom w-full text-sm">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  const isPinned = header.column.getIsPinned();
                  return (
                    <th
                      key={header.id}
                      className={` p-4 text-left pt-0  border-b border-black font-semibold text-secondary ${
                        isPinned === "right"
                          ? "sticky right-0 z-10 bg-gradient-to-r from-transparent to-white "
                          : isPinned === "left"
                            ? "sticky left-0 z-10 bg-black/30 backdrop-blur-sm"
                            : ""
                      }`}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length} className="h-24 text-center">
                  <div className="flex justify-center items-center">
                    <div className="border-primary border-b-2 rounded-full w-6 h-6 animate-spin" />
                  </div>
                </td>
              </tr>
            ) : table.getRowModel().rows?.length ? (
              table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  className={
                    
                    // slip border for last row
                    row.index === table.getRowModel().rows.length - 1
                      ? "border-b-0"
                      : "border-b border-black"
                  }
                >
                  {row.getVisibleCells().map((cell) => {
                    const isPinned = cell.column.getIsPinned();
                    return (
                      <td
                        key={cell.id}
                        className={`p-4 ${
                          isPinned === "right"
                            ? "sticky right-0 z-10 bg-gradient-to-r from-transparent to-white   "
                            : isPinned === "left"
                              ? "sticky left-0 z-10 bg-black/30 backdrop-blur-sm"
                              : ""
                        }`}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="h-24 text-center text-secondary"
                >
                  No results.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}